import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  Delete,
  GetAll,
  StatusItem,
} from "../../../../features/admin/master/pincode/Slice";
import {
  getAllCities,
  getAllCountries,
  getAllStates,
} from "../../../../features/admin/common/Slice";

export const IndexUse = () => {
  const dispatch = useDispatch();

  const [modalShow, setModalShow] = React.useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const countries = useSelector((state) => state.common.all_country);
  const states = useSelector((state) => state.common.all_states);
  const cities = useSelector((state) => state.common.all_cities);
  const pincode = useSelector((state) => state.masters.pincode);

  console.log(cities, "cities");

  const [name, setName] = useState("");
  const [country, setCountry] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");

  console.log(state, "state");

  useEffect(() => {
    dispatch(getAllCountries());
  }, [dispatch]);

  useEffect(() => {
    if (country) {
      dispatch(getAllStates({ countryId: country.value }));
    }
  }, [country, state, city, dispatch]);

  useEffect(() => {
    if (state) {
      dispatch(getAllCities(state.value));
    }
  }, [state, city, dispatch]);

  useEffect(() => {
    fetch();
  }, [country, state, city, name]);

  const fetch = async (page = pincode?.current_page) => {
    // await dispatch(AllCountry());
    await dispatch(
      GetAll({
        name: name,
        country_id: country.value,
        state_id: state.value,
        city_id: city.value,
        page: page,
        per_page: pincode?.per_page,
      }),
    );
  };

  const deleteData = async (id) => {
    try {
      await dispatch(Delete(id));
      setModalMessage("Deleted Successfully");
      setModalShow(true);
      await fetch();
      return true; // Success
    } catch (error) {
      setModalMessage("Delete Failed");
      setModalShow(true);
      console.error(error);
      return false; // Error
    }
  };

  const toggleStatus = async (id) => {
    try {
      const res = await dispatch(StatusItem(id));
      if (res.payload?.data?.success) {
        await fetch();
        setModalShow(true);
        return true;
      }
    } catch (error) {
      console.error(error);
      return false; // Error
    }
  };

  return {
    pincode,
    name,
    setName,
    fetch,
    deleteData,
    toggleStatus,
    country,
    countries,
    setCountry,
    state,
    states,
    setState,
    city,
    cities,
    setCity,
    modalMessage,
    modalShow,
    setModalShow,
  };
};
